// @ts-nocheck
/* eslint-disable-line react-hooks/exhaustive-deps */
import { Helmet } from 'react-helmet-async';
import VuiBreadcrumb from '../../../../../vodea/@vodea-ui/components/VuiBreadcrumb';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useMemo } from 'react';
import { useState } from '@hookstate/core/dist';
import { $clone, defaultActionFormatter } from '../../../../../vodea/utilities';
import { Link, useLocation } from 'react-router-dom';
import VuiDateRangePicker from '../../../../../vodea/@vodea-ui/components/Forms/VuiDateRangePicker';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../stores';
import CashMonitoringRepository from '../../../../../repositories/CashMonitoringRepository';
import { AxiosError, AxiosResponse } from 'axios';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { showToast } from '../../../../../vodea/utilities/helpers/global';
import WidgetRepository from '../../../../../repositories/WidgetRepository';
import VuiNumberFormat from '../../../../../vodea/@vodea-ui/components/VuiNumberFormat';
import useScroll from '../../../../../vodea/utilities/hooks/useScroll';
import DataTableInfiniteScroll, { ITableColumn } from '../../../../../vodea/@vodea-ui/components/DataTableInfiniteScroll';
import useIsMounted from '../../../../../vodea/utilities/hooks/useIsMounted';
import VuiSearch from '../../../../../vodea/@vodea-ui/components/VuiSearch';
import { DEFAULT_PAGE_SIZE } from '../../../../../constants';

const CashMonitoringList: React.FC<any> = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const isMounted = useIsMounted();
  const tableData = useState([]);
  const cashierData = useState([]);
  const permissions = useSelector((state: RootState) => state.permission.permission.permissions);
  const { isBottom } = useScroll();
  const [totalData, setTotalData] = React.useState<number>(0);
  const [hasMore, setHasMore] = React.useState<boolean>(false);
  const [isFetchingMoreData, setIsFetchingMoreData] = React.useState<boolean>(false);
  const [hasInitialize, setHasInitialize] = React.useState<boolean>(false);

  const title = t('Cash Monitoring');

  const tableConfig = useState({
    search: '',
    page: 1,
    per_page: DEFAULT_PAGE_SIZE,
    sorted_by: 'desc',
    order_by: 'date',
    total: 0,
    loading: false,

    // additional
    date_from: moment().format('YYYY-MM-DD'),
    date_to: moment().format('YYYY-MM-DD')
  });

  const tableColumns: ITableColumn[] = [
    {
      dataField: 'number',
      text: 'Number'
    },
    {
      dataField: 'cashier_name',
      text: 'Cashier'
    },
    {
      dataField: 'amount',
      text: 'Amount',
      render: (cell: any) => {
        return <VuiNumberFormat data={cell} prefix={'IDR '} />;
      }
    },
    {
      dataField: 'date',
      text: 'Created Date',
      render: (cell: any) => {
        return moment(cell).format('DD MMM YYYY');
      }
    },
    {
      dataField: 'action',
      text: 'Action',
      render: defaultActionFormatter,
      formatExtraData: {
        location: location.pathname,
        keyId: 'number',
        permission: 'cash-request',
        permissions: permissions
      }
    }
  ];

  const getCashier = () => {
    WidgetRepository.outstandingCashRequest()
      .then((Response: AxiosResponse) => {
        cashierData.set(Response.data.data);
      })
      .catch((e: AxiosError) => {
        showToast(e.message, 'error');
      });
  };

  const getTableData = async (reset: boolean = false, forNextPage: boolean = false) => {
    if (reset) tableConfig.page.set(1);
    if (isMounted.current && forNextPage) {
      setIsFetchingMoreData(true);
      tableConfig.page.set(tableConfig.page.get() + 1);
    } else {
      tableConfig.loading.set(true);
    }

    if (isMounted.current) {
      setHasMore(true);
    }

    const conf = _.omit($clone(tableConfig.value), ['loading', 'total']);

    let params: any = {};
    Object.keys(conf).forEach(prop => {
      if (conf[prop]) {
        params[prop] = conf[prop];
      }
    });

    if (isMounted.current && !forNextPage) tableData.set([]);

    await CashMonitoringRepository.all(params)
      .then((response: AxiosResponse) => {
        if (isMounted.current) {
          const { data: responseData } = response.data;
          tableData.merge(responseData);
          setIsFetchingMoreData(false);
          setHasInitialize(true);
          if (responseData.length == 0 || responseData.length < tableConfig.per_page.get()) {
            setHasMore(false);
          }
          tableConfig.loading.set(false);
          if (reset) {
            setTotalData(response.data.total_data);
          }
        }
      })
      .catch((e: AxiosError) => {
        if (e.isAxiosError) showToast(e.message, 'error');
        if (isMounted.current) {
          setHasInitialize(true);
          setIsFetchingMoreData(false);
          tableConfig.loading.set(false);
          setTotalData(0);
        }
      });
  };

  const breadcrumbList = [
    {
      label: 'Finance',
      link: '/finance'
    },
    {
      label: 'Cash Monitoring',
      link: '/finance/cash-monitoring'
    }
  ];

  const handleTableDateRange = (start: any, end: any) => {
    tableConfig.date_from.set(start.format('YYYY-MM-DD'));
    tableConfig.date_to.set(end.format('YYYY-MM-DD'));

    getTableData(true);
  };

  useMemo(() => {
    getCashier();
    getTableData(true);
  }, []);

  useMemo(() => {
    if (isBottom && hasInitialize && !isFetchingMoreData && hasMore) {
      getTableData(false, true);
    }
  }, [isBottom]);

  const handleTableSearch = (value: string) => {
    if (isMounted.current) {
      tableConfig.search.set(value);
      getTableData(true);
    }
  };

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <VuiBreadcrumb list={breadcrumbList} />

      <div className={'page-header-component'}>
        <h3 className={'title'}>Cash Monitoring</h3>
        {permissions.includes('cash-request.store') ? (
          <div className={'btn-wrapper'}>
            <Link to={'/finance/cash-monitoring/create'}>
              <button type={'button'} className={'btn btn-primary'}>
                <FontAwesomeIcon className={'icon icon-prefix'} icon={faPlus} />
                Request Cash
              </button>
            </Link>
          </div>
        ) : null}
      </div>

      {permissions.includes('widgetoutstanding-cash-request') && (
        <div className={'row'}>
          {cashierData.map((cashier: any, index: number) => (
            <div className={'col-md-3 mb-3'}>
              <div className={'card-paper'}>
                <div className={'card-header'}>
                  <h6 className={'card-header-title'}>
                    Cashier {cashier.cashier_id.get()} - {cashier.cashier_name.get()}
                  </h6>
                </div>
                <div className={'card-content'}>
                  <h5>
                    <VuiNumberFormat value={cashier.outstanding.get()} data={cashier.outstanding.get()} prefix={'IDR '} />
                  </h5>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {permissions.includes('cash-request.show') ? (
        <div className={'card-paper'}>
          <div className={'card-content'}>
            <div className={'default-filter-section'}>
              <div className={'filter-item filter-special'}>
                <VuiSearch value={tableConfig.search.get()} callback={handleTableSearch} />
              </div>

              <div className={'filter-item filter-special'}>
                <VuiDateRangePicker
                  startDate={tableConfig.date_from.get()}
                  endDate={tableConfig.date_to.get()}
                  callback={handleTableDateRange}
                  useRanges={true}
                />
              </div>
            </div>

            <DataTableInfiniteScroll
              columns={tableColumns}
              data={tableData.get()}
              propKey={'id'}
              isLoading={tableConfig.loading.get()}
              isFetchingMoreData={isFetchingMoreData}
              totalData={totalData}
            />
          </div>
        </div>
      ) : null}
    </>
  );
};

export default CashMonitoringList;
